export default __webpack_public_path__ + "static/media/logo_jnj_white.1eb67861.svg";